<template>
  <el-dialog
      :visible.sync="showAddQuestion"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <div class="dialog-main-content">
        <div style="margin-right: 10px">
          <div slot="title">
            <h1 class="dialog-title">{{ title }}</h1>
          </div>
          <!-- 查询条件 -->
          <div class="pat-search" style="display: flex">
            <el-select v-model="listQuery.redundant" prefix-icon="el-icon-search" size="small" filterable placeholder="请输入问卷名称">
              <el-option
                v-for="item in redundantList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="type-ques" style="margin: 0 10px">
              <span style="margin-right: 5px">问卷类型</span>
              <el-select v-model="listQuery.examTagId" size="small" placeholder="请选择问卷类型">
                <el-option
                  v-for="item in examTagList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-button size="small" @click="resetForm">重置</el-button>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          </div>
          <div class="main-content-list">
            <el-table :data="tableData" style="width: 100%" max-height="360">
              <el-table-column
                type="index"
                label="序号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="conent"
                label="问卷名称"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="tagName"
                label="问卷类型"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="feedbackTime"
                label="反馈时间"
                align="center"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="handleLook(scope.row)"
                    type="text"
                    size="small"
                  >
                    查看
                  </el-button>
                  <el-button
                    @click.native.prevent="assessmentSend(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >
                    发送
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div
            class="cardpage"
            style="text-align: right; margin-right: 30px; margin-top: 30px"
          >
            <el-pagination
              background
              :current-page="listQuery.current"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="listQuery.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
          </div>
        </div>
        <!-- 预览问卷 -->
        <previewQuestionDialog v-if="showQuestion" :showQuestion.sync="showQuestion" :typeFormDatas="typeFormData"/>
      </div>
    </el-dialog>
</template>
<script>
// import { questionnaireDetails } from "@/api/questionnaireManage"
// import previewQuestionDialog from '@/views/ToolMaintenance/component/previewQuestionDialog'
import previewQuestionDialog from './previewQuestionDialog.vue'
import { getPatientFeedbackByWholeCourseId, sendFeedback, getAnswerSheetLog } from "../../api/index"

export default {
  props: {
    showAddQuestion: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  components: {
    previewQuestionDialog
  },
  watch: {
    showAddQuestion(val) {
      this.visible = val
      if (val) {
        this.getQuesList()
        this.getInitData()
      }
    }
  },
  data() {
    return {
      paperId: '',
      visible: false,
      showQuestion: false,
      questionnaireList: [],
      questionTypeList: [],
      name: '',
      region: [],
      listQuery: {
        redundant: '',
        examTagId: '',
        title: '',
        current: 1,
        size: 10
      },
      redundantList: [],
      examTagList: [{
        label: '入案评估',
        value: 1
      }, {
        label: '疾病评估量表',
        value: 2
      }, {
        label: '疾病筛查量表',
        value: 3
      }, {
        label: '生活方式评估',
        value: 4
      }, {
        label: '功能评估',
        value: 5
      }, {
        label: '患者服务评价',
        value: 6
      }, {
        label: '心理评估',
        value: 7
      }, {
        label: '生存质量评估',
        value: 8
      }, {
        label: '随访问卷',
        value: 9
      }],
      total: 0,
      tableData: [],
      showQuestion: false,
      typeFormData: {},
    }
  },
  async created() {
    await this.getQuesList()
    await this.getInitData()
  },
  mounted() {},
  methods: {
    // async getQuestionData() {
    //   let { code, data } = await questionnaireDetails({
    //     id: this.paperId
    //   })
    //   if (code === 0) {
    //     this.quesData = data
    //   }
    // },
    // 重置
    resetForm() {
      Object.assign(this.listQuery, { redundant: '', examTagId: '', title: '', current: 1, size: 10 })
    },
    handleClose() {
      this.$emit('update:showAddQuestion', false)
    },
    handleAdd(row) {
      this.$emit('receiveQuestion', row)
      this.$emit('update:showAddQuestion', false)
    },
    // 获取详情
    async getPageDetail() {
      let { code, data } = await getAnswerSheetLog({
        answerSheetId: this.paperId
      })
      if (code === 0) {
        this.typeFormData = data
      }
    },
    // 搜索
    async handleSearch() {
      Object.assign(this.listQuery, { ...this.listQuery, current: 1, size: 10 })
      this.getInitData()
    },
    // 查看
    async handleLook(row) {
      this.paperId = row.refId
      await this.getPageDetail()
      this.showQuestion = true
    },
    async getInitData() {
      // 分页等待
      let { code, data: { records, total } } = await getPatientFeedbackByWholeCourseId({ ...this.listQuery, wholeCourseId: this.$store.state.wholeCourseId})
      if (code === 0) {
        this.tableData = records.map(item => {
          return {
            ...item
          }
        })
        this.total = total
      }
    },
    // 问卷名称模糊搜索
    async getQuesList() {
      let { code, data: { records, total } } = await getPatientFeedbackByWholeCourseId({ ...this.listQuery, wholeCourseId: this.$store.state.wholeCourseId})
      if (code === 0) {
        this.redundantList = records.map(item => {
          return {
            value: item.conent,
            label: item.conent
          }
        })
      }
    },
    handleSizeChange(val) {
      this.listQuery.size = val
      this.handleSearch()
    },
    handleCurrentChange(val) {
      this.listQuery.current = val
      this.handleSearch()
    },
    // 发送反馈评估问卷
    async assessmentSend(index, row) {
      let { code, data } = await sendFeedback(row.id)
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '问卷发送成功'
        })
      }
      // 会发送一个卡片需要特殊配置
    }
  }
}
</script>
<style lang="less" scoped>
// .list-question-wrap {
//   // height: 100%;
// }
/deep/.el-dialog {
  // max-width: 80%;
  // min-width: 50%;
  width: fit-content;
}
/deep/.el-dialog__body {
  padding-top: 0px;
}
/deep/.el-dialog__header {
  padding-left: 35px;
}
.search-btns {
  margin-top: 5px;
}
.el-main {
    width: 100%;
    .main-content-list {
      height: 56vh;
      overflow: auto;
      padding: 15px;
      padding-top: 8px;
      background-color: #fff;
    }
}
.el-pagination {
  text-align: right;
  margin-top: 15px;
  margin-right: 40px;
}
.btn-bg {
  background:#1A7BFC;
  color: #fff;
}
.dialog-main-content {
  display: flex;
  .dialog-title {
    font-size: 26px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
    margin-bottom: 8px;
    text-align: center;
    line-height: 2;
  }
}
/deep/.el-table td {
  padding: 6px 0;
}
</style>
